var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { Menu as BaseMenu, MenuButton as BaseMenuButton, MenuItem as BaseMenuItem, MenuLink as BaseMenuLink, MenuPopover, } from '@reach/menu-button';
import React from 'react';
import Button from '../Button/Button';
export function Menu(_a) {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return _jsx(BaseMenu, Object.assign({}, rest, { children: children }));
}
export function MenuButton(_a) {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (_jsx(Button, Object.assign({ as: BaseMenuButton }, rest, { children: children })));
}
export function MenuList(_a) {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (_jsx(MenuPopover, Object.assign({ sx: {
            display: 'block',
            whiteSpace: 'nowrap',
            border: 1,
            borderColor: 'border',
            backgroundColor: 'nuanced',
            outline: 'none',
            boxShadow: 'overlay',
            variant: 'text.small',
            zIndex: 'elevated',
        } }, rest, { 
        //@ts-ignore - reach-ui types are wrong (or we are using them wrong)
        portal: "true" }, { children: children })));
}
/**
 * @param {{children: React.ReactNode; onSelect: ()=>any; [x: string]:any}} props
 * @returns
 */
export function MenuItem(_a) {
    var { children, onSelect } = _a, rest = __rest(_a, ["children", "onSelect"]);
    return (_jsx(BaseMenuItem, Object.assign({ sx: {
            display: 'block',
            userSelect: 'none',
            cursor: 'pointer',
            color: 'inherit',
            textDecoration: 'initial',
            paddingY: 1,
            paddingX: 3,
            '&[data-selected]': {
                backgroundColor: 'primary',
                color: 'onPrimary',
                outline: 'none',
            },
        }, onSelect: onSelect }, rest, { children: children })));
}
export function MenuLink(_a) {
    var { children } = _a, rest = __rest(_a, ["children"]);
    return (_jsx(BaseMenuLink, Object.assign({ sx: {
            display: 'block',
            userSelect: 'none',
            cursor: 'pointer',
            color: 'inherit',
            textDecoration: 'initial',
            paddingY: 1,
            paddingX: 3,
            '&[data-selected]': {
                backgroundColor: 'primary',
                color: 'onPrimary',
                outline: 'none',
            },
        } }, rest, { children: children })));
}
//# sourceMappingURL=Menu.js.map